import { ReactElement } from "react";

interface Props {
    children: ReactElement[];
}

export default function ShowcaseSection({ children }: Props) {
  return (
    <div className="universaleditmodal-right-content">
      <div className="universaleditmodal-right-content-text">
        <div className="universaleditmodal-right-content-text-title">
          Витрина
        </div>
        <div className="universaleditmodal-right-content-text-description">
          Выберите то, чем хотите поделиться
        </div>
      </div>
      {children}
    </div>
  );
}
